import { Box, ColorOptions, IconNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { FlatList, View } from 'react-native'
import { useStores } from '../../../data/store'

const menuList = [
  { id: '1', title: 'Account Summary', isSelected: true, subMenu: [] },
  { id: '2', title: 'Business Hierarchy', isSelected: false, subMenu: [] },
  // { id: '5', title: 'Audit Trial', isSelected: false, subMenu: [] },
  { id: '3', title: 'TID List', isSelected: false, subMenu: [] },
  { id: '4', title: 'Devices', isSelected: false, subMenu: [] },
]

const menuListMakerChecker = [
  { id: '1', title: 'Account Summary', isSelected: true, subMenu: [] },
  { id: '3', title: 'TID List', isSelected: false, subMenu: [] },
  { id: '4', title: 'Devices', isSelected: false, subMenu: [] },
]

const emsMenuList = [
  { id: '1', title: 'Account Summary', isSelected: true, subMenu: [] },
  { id: '2', title: 'Business Hierarchy', isSelected: false, subMenu: [] },
]
const makerCheckerEmsMenuList = [{ id: '1', title: 'Account Summary', isSelected: true, subMenu: [] }]
const masSubMenu = [
  { id: '6', title: '    Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: '    Contact Profiles', isSelected: false, subMenu: [] },
  { id: '8', title: '    Settlement Details', isSelected: false, subMenu: [] },
  // { id: '9', title: 'KYC Details', isSelected: false, subMenu: [] },
  { id: '10', title: '    Settings', isSelected: false, subMenu: [] },
  { id: '9', title: '    KYC & Documentation', isSelected: false, subMenu: [] },
]

const makerCheckerMasSubMenu = [
  { id: '6', title: '    Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: '    Contact Profiles', isSelected: false, subMenu: [] },
  { id: '8', title: '    Settlement Details', isSelected: false, subMenu: [] },
  // { id: '9', title: '    KYC & Documentation', isSelected: false, subMenu: [] },
]

const emsSubMenu = [
  { id: '6', title: '    Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: '    Contact Profiles', isSelected: false, subMenu: [] },
  // { id: '9', title: '    KYC & Documentation', isSelected: false, subMenu: [] },
  // { id: '8', title: '    Settlement Details', isSelected: false, subMenu: [] },
  // { id: '9', title: 'KYC Details', isSelected: false, subMenu: [] },
]

const emsSettlementDetailsMenu = [
  { id: '6', title: '    Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: '    Contact Profiles', isSelected: false, subMenu: [] },
  { id: '8', title: '    Settlement Details', isSelected: false, subMenu: [] },
]
const myQueueGroupList = [
  { id: '6', title: 'Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: 'Contact Profiles', isSelected: false, subMenu: [] },
]

const entityName = [
  { id: '1', title: 'Account Summary', isSelected: true, subMenu: [] },
  { id: '2', title: 'Business Hierarchy', isSelected: false, subMenu: [] },
  // { id: '3', title: 'TID List', isSelected: false, subMenu: [] },
]

const entityNameSubMenu = [
  { id: '6', title: '    Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: '    Contact Profiles', isSelected: false, subMenu: [] },
]

const groupId = [
  // { id: '2', title: 'Business Hierarchy', isSelected: false, subMenu: [] },
  // { id: '5', title: 'Audit Trial', isSelected: false, subMenu: [] },
  { id: '6', title: 'Business Details', isSelected: false, subMenu: [] },
  { id: '7', title: 'Contact Profiles', isSelected: false, subMenu: [] },
  // { id: '9', title: 'KYC & Documentation', isSelected: false, subMenu: [] },
]

const subGroupId = [
  { id: '6', title: 'Business Details', isSelected: false, subMenu: [] },
  { id: '9', title: 'KYC & Documentation', isSelected: false, subMenu: [] },
]

const Item = ({ data, onPress, selectedId, isSubMenu }: any) => {
  const onHandlePress = () => {
    onPress(data)
  }
  return (
    <Box
      h={isSubMenu ? 42 : 60}
      padding={16}
      flexDirection={'row'}
      alignItems={'center'}
      width={'100%'}
      onPress={onHandlePress}
      underlayColor={'TRANSPARENT'}
      backgroundColor={data?.id === selectedId ? ('#0070B60F' as ColorOptions) : undefined}>
      <Box flexDirection={'row'}>
        <Spacer size={16} direction={'horizontal'} />
        <Box flex={1} alignItems={'center'} justifyContent={'space-around'} flexDirection={'row'}>
          <Spacer size={16} direction={'horizontal'} />
          <Box w={169}>
            <Text
              textAlign="left"
              title={data?.title}
              fontFamily={'jiotype-medium'}
              fontSize={14}
              color={'#0070B6' as ColorOptions}
            />
          </Box>
        </Box>
      </Box>
      <ModBox w={2} show={data?.id === selectedId}>
        <View style={{ width: 2, height: isSubMenu ? 42 : 60, backgroundColor: '#0070B6' }} />
      </ModBox>
    </Box>
  )
}
const MenuItem = ({ item, onItemPress, selectedId, isSubMenu }: any) => {
  return (
    <ModBox>
      <Item data={item} onPress={onItemPress} selectedId={selectedId} isSubMenu={isSubMenu} />
    </ModBox>
  )
}

const Menu = ({ selectedScreen, from, selectedEntity, getSubMenuExpanded, selectedScreenId = '1' }: any) => {
  const selectedId = selectedScreenId.toString()
  const { searchFilterBy, isEntityPresentInMas, getOnboardingChannel } = useStores((store) => ({
    searchFilterBy: store.onboarding.searchFilterBy,
    isEntityPresentInMas: store.onboarding.isEntityPresentInMas,
    getOnboardingChannel: store.getOnboardingChannel,
  }))

  const [isExpanded, setIsExpanded] = useState(false)
  const [menuListData, setMenuListData] = useState([])
  const [updatedSubMenu, setUpdatedSubMenu] = useState([])
  const [isMenuSet, setMenu] = useState(false)

  const getMakerCheckerSubMenu = () => {
    return selectedEntity && (selectedEntity?.requestType === 'SUBGROUP' || selectedEntity?.requestType === 'GROUP')
      ? []
      : selectedEntity?.source === 'MAS'
      ? makerCheckerMasSubMenu
      : emsSubMenu
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getSubMenuByType = (type: string) => {
    const obj: any = {
      'Entity Name': getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      'SubGroup ID': [],
      'Group ID': [],
      'Entity ID': getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      'Mobile Number': getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      'Email Id': getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      'Device Serial No.': getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      'Store Code': getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      VPA: getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      Pincode: getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      TID: getSubMenu(isEntityPresentInMas(selectedEntity?.id)),
      CHECKER_MYQUEUE: getMakerCheckerSubMenu(),
      CHECKER_QUEUE: getMakerCheckerSubMenu(),
      MAKER_QUEUE: getMakerCheckerSubMenu(),
    }
    return obj[type] ?? menuList
  }

  useEffect(() => {
    getSubMenuExpanded(isExpanded)
  }, [getSubMenuExpanded, isExpanded])

  useEffect(() => {
    if (!isMenuSet) {
      const datalist = getSubMenuByType(
        from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE' ? from : searchFilterBy,
      )
      console.log('menu-test submenu', datalist)
      setUpdatedSubMenu(datalist)
      setMenu(true)
    }
  }, [from, getSubMenuByType, isMenuSet, searchFilterBy])

  useEffect(() => {
    if (selectedScreenId === '1') {
      setIsExpanded(false)
      selectedScreen(1)
    }
  }, [selectedScreen, selectedScreenId])

  const getSubMenu = (isMasEntity: boolean) => {
    const onboardingChannel = getOnboardingChannel(selectedEntity?.id)
    console.log('menu-test getSubMenu: ', isMasEntity, selectedEntity?.type, onboardingChannel)
    return selectedEntity?.type === '101' ? emsSettlementDetailsMenu : masSubMenu

    // if (onboardingChannel === 'DigitalKYC') {
    //   return masSubMenu
    // } else {
    //   return isMasEntity ? masSubMenu : selectedEntity?.type === '101' ? emsSettlementDetailsMenu : emsSubMenu
    // }
  }

  const getMenu = (isMasEntity: boolean, onboardingChannel: any) => {
    console.log('menu-test menu: ', isMasEntity, onboardingChannel)
    return menuList

    // if (onboardingChannel === 'DigitalKYC') {
    //   return menuList
    // } else {
    //   return isMasEntity ? menuList : emsMenuList
    // }
  }

  console.log('htag selectedEntity', selectedEntity)

  const getMakerCheckerMainMenu = () => {
    return selectedEntity && selectedEntity?.requestType === 'SUBGROUP'
      ? subGroupId
      : selectedEntity && selectedEntity?.requestType === 'GROUP'
      ? myQueueGroupList
      : selectedEntity?.requestType === 'MERCHANT' && selectedEntity?.source === 'MAS'
      ? menuListMakerChecker
      : makerCheckerEmsMenuList
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getMenuByType = (type: string) => {
    const obj: any = {
      CHECKER_MYQUEUE: getMakerCheckerMainMenu(),
      CHECKER_QUEUE: getMakerCheckerMainMenu(),
      MAKER_QUEUE: getMakerCheckerMainMenu(),
      'Entity Name': entityName,
      'Group ID': groupId,
      'SubGroup ID': subGroupId,
    }
    const onboardingChannel = getOnboardingChannel(selectedEntity?.id)
    return obj[type] ?? getMenu(isEntityPresentInMas(selectedEntity?.id), onboardingChannel)
  }

  useEffect(() => {
    const datalist = getMenuByType(from !== undefined ? from : searchFilterBy)
    setMenuListData(datalist)
  }, [from, getMenuByType, searchFilterBy])

  const renderMenuItems = ({ item }: any) => {
    const onItemPress = (selectedItem: any) => {
      selectedScreen(selectedItem?.id)
    }
    return <MenuItem item={item} onItemPress={onItemPress} selectedId={selectedId} isSubMenu={false} key={item?.id} />
  }
  const onAccountDetailsPress = () => {
    setIsExpanded((prev) => !prev)
  }
  const onItemPress = (item: any) => {
    selectedScreen(item?.id)
  }

  return (
    <ModBox backgroundColor={'#0070B614' as ColorOptions} overflow={'visible'}>
      <FlatList renderItem={renderMenuItems} data={getMenuByType(from !== undefined ? from : searchFilterBy)} />
      <ModBox show={updatedSubMenu && updatedSubMenu.length > 0}>
        <ModBox
          show={updatedSubMenu.length > 0}
          h={60}
          padding={16}
          flexDirection={'row'}
          alignItems={'center'}
          width={'100%'}
          onPress={onAccountDetailsPress}
          underlayColor={'TRANSPARENT'}>
          <ModBox flexDirection={'row'}>
            <Spacer size={16} direction={'horizontal'} />
            <Box alignItems={'center'} justifyContent={'space-around'} flexDirection={'row'}>
              <Spacer size={16} direction={'horizontal'} />
              <Box>
                <Text
                  textAlign="left"
                  title={'Account Details'}
                  fontFamily={'jiotype-medium'}
                  fontSize={14}
                  color={'#0070B6' as ColorOptions}
                />
              </Box>
              <Spacer size={16} direction={'horizontal'} />
              <IconNew id={isExpanded ? 'ARROW_UP' : 'ARROW_DOWN'} color={'BLUE'} size={20} />
            </Box>
          </ModBox>
        </ModBox>
        <ModBox show={isExpanded && updatedSubMenu && updatedSubMenu.length > 0} h={'100%'}>
          {updatedSubMenu?.map((mData: any, index: number) => {
            return (
              <MenuItem item={mData} onItemPress={onItemPress} selectedId={selectedId} isSubMenu={true} key={index} />
            )
          })}
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export { Menu }
